import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

export const ContextForm = ({ context, setContext, generating, onGenerate }) => (
  <Card className="p-6">
    <h3 className="text-xl font-serif font-normal text-stone-900 mb-4">Provide Context</h3>
    <div className="space-y-4">
      <div>
        <Label htmlFor="unit_title">Unit Title *</Label>
        <Input
          id="unit_title"
          value={context.unit_title}
          onChange={(e) => setContext({ ...context, unit_title: e.target.value })}
          placeholder="e.g., The American Revolution"
          data-testid="unit-title-input"
        />
      </div>
      <div>
        <Label htmlFor="topic">Specific Topic *</Label>
        <Input
          id="topic"
          value={context.topic}
          onChange={(e) => setContext({ ...context, topic: e.target.value })}
          placeholder="e.g., Causes of the Revolution"
          data-testid="topic-input"
        />
      </div>
      <div>
        <Label htmlFor="learning_objectives">Learning Objectives</Label>
        <Textarea
          id="learning_objectives"
          value={context.learning_objectives}
          onChange={(e) => setContext({ ...context, learning_objectives: e.target.value })}
          placeholder="What should students learn?"
          rows={3}
        />
      </div>
      <div>
        <Label htmlFor="grade_level">Grade Level</Label>
        <Select
          value={context.grade_level.toString()}
          onValueChange={(val) => setContext({ ...context, grade_level: parseInt(val) })}
        >
          <SelectTrigger id="grade_level">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="9">Grade 9</SelectItem>
            <SelectItem value="10">Grade 10</SelectItem>
            <SelectItem value="11">Grade 11</SelectItem>
            <SelectItem value="12">Grade 12</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor="additional_notes">Additional Notes</Label>
        <Textarea
          id="additional_notes"
          value={context.additional_notes}
          onChange={(e) => setContext({ ...context, additional_notes: e.target.value })}
          placeholder="Any specific requirements or focus areas?"
          rows={2}
        />
      </div>
      <Button onClick={onGenerate} disabled={generating} className="w-full btn-primary" data-testid="generate-lesson-btn">
        {generating ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Generating...
          </>
        ) : (
          <>
            <Sparkles className="h-4 w-4 mr-2" />
            Generate Lesson Plan
          </>
        )}
      </Button>
    </div>
  </Card>
);
